import React, { useEffect, useState } from "react";
import { MDBRow } from "mdb-react-ui-kit";
import axios from "axios";
import add from "../../../images/black-add.png";
import Skeleton from "@mui/material/Skeleton";
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
// config
import configData from "../../../config/config.json";

const InformationStep5 = () => {
  const [disable, setDisable] = useState(false);

  const [show, setShow] = useState(false);
  const [dataCome, setDataCome] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const updateShow = () => {
    setShow(true);
  };
  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  const [categories, setCategories] = useState([]);
  const [active, seActive] = useState([]);
  // const [active, seActive] = useState([]);

  const handleChange = (event, id) => {
    if (event.target.checked) {
      if (!active.includes(event.target.value)) {
        seActive((active) => [...active, event.target.value]);
      }
    } else {
      // console.log("here");
      seActive(active.filter((item) => item !== event.target.value));
    }
    // console.log(active);
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };
  //api header
  const headerActive = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);

    axios
      .get(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/categoryOptions`,
        {
          headers: header,
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          let data = response.data.data;

          // set data to states
          setCategories(data.options);
          for (let index = 0; index < data.options.length; index++) {
            const element = data.options[index];
            if (element.isSelected) {
              if (!active.includes(element.cotId)) {
                const elementb = element.cotId + "";

                seActive((active) => [...active, elementb]);
              }
            }
          }
          setDataCome(true);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // load api by aidin
    // axios
    //   .get(domain + "/api/biz/category-options-selected", {
    //     headers: headerActive,
    //   })
    //   .then((response) => {
    //     setDataCome(true);

    //     if (response.data.msg == "done") {
    //       setCategories(response.data.Options);

    //       for (let index = 0; index < response.data.Options.length; index++) {
    //         const element = response.data.Options[index];
    //         if (element.IsSelected) {
    //           if (!active.includes(element.COTId)) {
    //             const elementb = element.COTId + "";

    //             seActive((active) => [...active, elementb]);
    //           }
    //         }
    //       }
    //     } else {
    //       setCategories([]);
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  }, []);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const ownerId = getCookie("BizId");
    var amenities = "";
    for (let index = 0; index < active.length; index++) {
      const element = active[index];
      if (element) {
        if (index == 0) {
          amenities = element;
        } else {
          amenities = amenities + "," + element;
        }
      }
    }

    const dataPost = {
      amenities,
      bId: getCookie("BizId"),
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/categoryOptions`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);

        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });
    // save api by aidin
    // axios
    //   .post(domain + "/api/biz/category-options-selected-update", dataPost, {
    //     headers: header,
    //   })
    //   .then((response) => {
    //     setDisable(false);
    //     if (response.data.msg == "done") {
    //       // success
    //       alertHandeler();
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  };

  return (
    <>
      <div className="part_five_info">
        <div className="step3_header"></div>
        <MDBRow className="mx-0">
          <div className="col-12  step2_radio register-business-padd">
            <div className="">
              <div dir="rtl" className="rbtn-s3a row mb-n2 mb-md-0 mt-0">
                {dataCome ? (
                  // active.length > 0 &&
                  categories.length > 0 ? (
                    categories.map((item) => (
                      <div className="col-12 col-md-6" key={item.cotId}>
                        <label className="container-s2" id={item.cotId}>
                          <input
                            onChange={(event) =>
                              handleChange(event, item.cotId)
                            }
                            type="checkbox"
                            id={item.cotId}
                            name={item.cotId}
                            value={item.cotId}
                            // defaultChecked={
                            //   active.includes(item.cotId) ? true : false
                            // }
                            defaultChecked={
                              active.includes(`${item.cotId}`) ? true : false
                            }
                          />
                          {/* {console.log(active.includes(item.cotId))} */}
                          {/* {console.log(active)} */}
                          <span className="checkmark-s2 checkmark-s2-info"></span>
                          <span>{item.title}</span>
                        </label>
                      </div>
                    ))
                  ) : (
                    <div className="text-align-center centerr">
                      موردی برای نمایش وجود ندارد.
                    </div>
                  )
                ) : (
                  <>
                    <div className="col-12 col-md-6">
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-2 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>{" "}
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-2 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>{" "}
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-1 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-2 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          // variant="rectangular"
                          // width={123}
                          // height={5}
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>{" "}
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-2 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          // variant="rectangular"
                          // width={123}
                          // height={5}
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>{" "}
                      <div className="d-flex justify-content-right me-4 me-md-3  mt-1 mb-2 me-1">
                        <Skeleton
                          className=""
                          variant="rectangular"
                          width={16}
                          height={16}
                          animation="wave"
                          rounded
                        />
                        <Skeleton
                          className="w-100 me-3"
                          // variant="rectangular"
                          // width={123}
                          // height={5}
                          variant="text"
                          sx={{ fontSize: "0.5rem" }}
                          animation="wave"
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* {width < 767 && !show && (
                  <span onClick={updateShow}>
                    {" "}
                    <img
                      src={add}
                      alt="..."
                      className="bus-dash-info5-moreimg"
                    />
                    <span className="bus-dash-info5-more">بیشتر</span>
                  </span>
                )} */}

                {(width > 767 || show) && <></>}
              </div>
            </div>
          </div>
          <div className="div_button_step5_info step2_save_c p-0">
            {categories.length > 0 ? (
              dataCome ? (
                <button
                  onClick={submitHandler}
                  disabled={disable}
                  className="btn_information_submit"
                >
                  ذخیره اطلاعات
                </button>
              ) : (
                <Skeleton
                  className="btn_information_submit me-auto"
                  variant="rectangular"
                  height={39}
                  animation="wave"
                />
              )
            ) : (
              <></>
            )}
          </div>
        </MDBRow>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
    </>
  );
};

export default InformationStep5;
